(() => {
  if (window.__ornataBoutiqueEnhancementsLoaded) return;
  window.__ornataBoutiqueEnhancementsLoaded = true;

  const createPartyPicker = (root) => {
    const select = root.querySelector('select[name="partySize"]');
    if (!(select instanceof HTMLSelectElement)) return;

    const field = select.closest('[data-field="partySize"]');
    const nativeControl = select.closest('.form-control');
    if (!(field instanceof HTMLElement) || !(nativeControl instanceof HTMLElement)) return;
    if (field.querySelector('.obv-party-picker')) return;

    nativeControl.classList.add('obv-party-native');
    nativeControl.setAttribute('aria-hidden', 'true');

    const picker = document.createElement('div');
    picker.className = 'obv-party-picker';
    picker.innerHTML = `
      <span class="obv-party-label">Aantal personen</span>
      <div class="obv-party-options" role="radiogroup" aria-label="Aantal personen">
        <button type="button" class="button button--outline button--sm obv-party-option" data-party-value="1" role="radio">1 persoon</button>
        <button type="button" class="button button--outline button--sm obv-party-option" data-party-value="2" role="radio">2 personen</button>
      </div>
    `;

    nativeControl.insertAdjacentElement('afterend', picker);

    const sync = () => {
      picker.querySelectorAll('[data-party-value]').forEach((button) => {
        const selected = button.getAttribute('data-party-value') === select.value;
        button.classList.toggle('is-selected', selected);
        button.setAttribute('aria-checked', selected ? 'true' : 'false');
      });
    };

    picker.addEventListener('click', (event) => {
      const button = event.target instanceof Element ? event.target.closest('[data-party-value]') : null;
      if (!(button instanceof HTMLButtonElement)) return;

      select.value = button.dataset.partyValue || '1';
      select.dispatchEvent(new Event('change', { bubbles: true }));
      sync();
    });

    select.addEventListener('change', sync);
    sync();
  };

  const enhance = (root) => {
    if (!root || root.dataset.obvEnhancementsReady === 'true') return;
    root.dataset.obvEnhancementsReady = 'true';
    root.classList.add('obv-auto-advance-ready');

    createPartyPicker(root);

    root.addEventListener('click', (event) => {
      const target = event.target;
      const timeButton = target instanceof Element ? target.closest('.obv-time') : null;
      if (!(timeButton instanceof HTMLButtonElement)) return;

      requestAnimationFrame(() => {
        const nextButton = root.querySelector('[data-to-details]');
        if (nextButton instanceof HTMLButtonElement) nextButton.click();
      });
    });
  };

  const enhanceAll = (scope = document) => {
    scope.querySelectorAll?.('.ornata-boutique-v2').forEach(enhance);
    if (scope instanceof Element && scope.matches('.ornata-boutique-v2')) enhance(scope);
  };

  enhanceAll();

  document.addEventListener('shopify:section:load', (event) => {
    if (event.target instanceof Element) enhanceAll(event.target);
  });
})();
